var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('v-container',{staticClass:"my-4 google-font",attrs:{"fluid":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":""}},[_c('v-flex',{attrs:{"xs12":"","lg8":"","xl6":""}},[_c('v-card',[_c('RequestQuote')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }